import { ReductionTypeEnum } from '../../lib/types/enums/cse/reduction-type.enum'
import { ApplicationStatusEnum } from '../../lib/types/enums/enrollment/application-status.enum'
import { EnrollmentPropositionRequest } from '../../lib/types/models/enrollment-proposition/enrollment-proposition-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'
import { TariffAdjustment } from './create-tariff-adjustment'

export type EnrollmentPropositionSummaryType = {
  baseJourneyPrice: number
  mainOptionPrice: number
  familyArrangmentPrice: number
  mainTrip: number
  secondaryTrip: number
  accomodationCosts: number
  applicationFee: number
  familyDiscount: number
  tariffAdjustments?: TariffAdjustment[]
  options: { id: number; title: string; price: number }[]
  insurances: { id: number; name: string; price: number }[]
  cse: { discount: number; type: ReductionTypeEnum } | null
  promoCode: { discount: number; includedInsurance: boolean; type: ReductionTypeEnum } | null

  totalBeforeDiscount: number
  total: number
}

export const getEnrollmentPropositionPricing = async (
  data: EnrollmentPropositionRequest & { status?: ApplicationStatusEnum }
): Promise<EnrollmentPropositionSummaryType> => {
  return restApiClient
    .url(constructApiUrl(API.enrollments.getEnrollmentPropositionPricing.url, null))
    .post<EnrollmentPropositionSummaryType, EnrollmentPropositionRequest>(data)
}

export const getEnrollmentPropositionPricingById = async (input: {
  enrollmentId: number
  propositionId: number
}): Promise<EnrollmentPropositionSummaryType> => {
  const { enrollmentId, propositionId } = input
  return restApiClient
    .url(
      constructApiUrl(API.enrollments.getEnrollmentPropositionPricingById.url, {
        id: enrollmentId,
        propositionId
      })
    )
    .get<EnrollmentPropositionSummaryType>()
}
